import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable()
export class UserProfileService {

controller = 'UserProfile';

constructor(private base: BaseService) { }


getforProfile(id):Observable<ApiObjectData> {
  return this.base.gets(this.controller+'/GetForProfile/'+id);
}


}
